import { render } from "./KemaskiniAmpun.vue?vue&type=template&id=30269849"
import script from "./KemaskiniAmpun.vue?vue&type=script&lang=js"
export * from "./KemaskiniAmpun.vue?vue&type=script&lang=js"

import "./KemaskiniAmpun.vue?vue&type=style&index=0&id=30269849&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__